var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useLucidSdk } from '#context';
import { CapabilitiesKeyFactory, CurrentMemberKeyFactory, IndividualInvitationsKeyFactory, WorkspaceMembersKeyFactory, WorkspacesKeyFactory, } from '../../query-key-factories';
export const useCreateIndividualInvitation = (workspaceId, { onError, onSuccess } = {}) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: (invitationPayload) => lucidSdk
            .workspaceClient(workspaceId)
            .invitationManagement()
            .createIndividualInvitation(invitationPayload.emailFilters, invitationPayload.groups),
        onSuccess: async (data) => {
            try {
                await Promise.all([
                    // Update current workspace member
                    queryClient.refetchQueries({
                        exact: true,
                        queryKey: CurrentMemberKeyFactory.byWorkspace(workspaceId),
                    }),
                    // Update workspace members - update members table
                    queryClient.refetchQueries({
                        queryKey: WorkspaceMembersKeyFactory.allByWorkspace(workspaceId),
                    }),
                    // Update individual invitations list
                    queryClient.refetchQueries({
                        exact: true,
                        queryKey: IndividualInvitationsKeyFactory.byWorkspace(workspaceId),
                    }),
                    // Update workspace data
                    // so we know if the user is
                    // allowed or not to invite more members
                    queryClient.refetchQueries({
                        exact: true,
                        queryKey: WorkspacesKeyFactory.byWorkspace(workspaceId),
                    }),
                    // Update billing capabilities as members current / pending / max is also there
                    queryClient.refetchQueries({
                        exact: true,
                        queryKey: CapabilitiesKeyFactory.membersCapabilities(workspaceId),
                    }),
                ]);
            }
            finally {
                if (typeof onSuccess === 'function') {
                    onSuccess(data);
                }
            }
        },
        onError: (error) => {
            if (typeof onError === 'function') {
                onError(error);
            }
        },
        networkMode: 'always',
    });
    return {
        mutation,
    };
};
_react_refresh_temp_1(useCreateIndividualInvitation, "s074ag8lSG2K0z8InO7Yl75Raxc=", false, () => [useLucidSdk, useQueryClient, useMutation]);
